export class ControlRules {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "minimumRetention",
            "baseName": "minimumRetention",
            "type": "Array<MinRetentionRule>",
            "format": ""
        },
        {
            "name": "maximumRetention",
            "baseName": "maximumRetention",
            "type": "MaxRetentionRule",
            "format": ""
        },
        {
            "name": "numberOfCopies",
            "baseName": "numberOfCopies",
            "type": "NumberOfCopiesRule",
            "format": ""
        },
        {
            "name": "crossRegion",
            "baseName": "crossRegion",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "crossAccount",
            "baseName": "crossAccount",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "crossCloudProvider",
            "baseName": "crossCloudProvider",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "backup321",
            "baseName": "backup321",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "eonBackupEnabled",
            "baseName": "eonBackupEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "generalBackupEnabled",
            "baseName": "generalBackupEnabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ControlRules.attributeTypeMap;
    }
    constructor() {
    }
}
